module.exports = __webpack_public_path__ + "img/Gun.41823c7c.svg";